import Logo from "../../assets/images/Bodybon-TypeLogo.png";
import ComingSoonImg from "../../assets/images/coming-soon.svg";

const ComingSoon = () => {
  return (
    <div className="min-h-screen min-w-screen flex flex-col justify-start items-center py-20 lg:py-10 px-5 bg-[#FCFCFC]">
      <img src={Logo} className="w-7/12 lg:w-[250px] mb-16" />

      <h1 className="font-rokh font-[700] text-xl lg:text-2xl mb-5 text-center">
        در حال استرلیزه کردن محیط سایت هستیم <br /> به‌زودی برمی‌گردیم
      </h1>

      <img src={ComingSoonImg} className="lg:w-[500px] w-full" />
    </div>
  );
};

export default ComingSoon;
